import { Input } from "@progress/kendo-react-inputs";
import { BorderCrossingResult } from "../../../TypeGen/Order/Planning/border-crossing-result";

type BorderCrossingReferenceInputsProps = {
  borderReference: BorderCrossingResult;
  onParsChange: (value: string) => void;
  onPapsChange: (value: string) => void;
};

const BorderCrossingReferenceNumberInputs = ({ borderReference, onParsChange, onPapsChange }: BorderCrossingReferenceInputsProps) => {
  if (!borderReference?.ShowBorderReferences) {
    return null;
  }

  return (
    <>
      {borderReference.ShowPARS && (
        <div className="form-group row">
          <label htmlFor="parsNumber" className="col-form-label col-md-3">PARS</label>
          <div className="col-md-9">
            <Input
              id="parsNumber"
              required
              style={{ width: 210 }}
              maxLength={40}
              value={borderReference.PARS || ""}
              onChange={(event) => onParsChange(event.value)}
              placeholder="PARS Number"
            />
          </div>
        </div>
      )}
      {borderReference.ShowPAPS && (
        <div className="form-group row">
          <label htmlFor="papsNumber" className="col-form-label col-md-3">PAPS</label>
          <div className="col-md-9">
            <Input
              id="papsNumber"
              required
              style={{ width: 210 }}
              maxLength={40}
              value={borderReference.PAPS || ""}
              onChange={(event) => onPapsChange(event.value)}
              placeholder="PAPS Number"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default BorderCrossingReferenceNumberInputs;